import {
    ACTION_RESULT_CLOSE,
    ACTION_RESULT_NORMAL,
    ACTION_RESULT_STOP_RULESET,
} from './actionResults';
import { CLOSE } from './resultTypes';
import {
    ACTION_TYPE_SWITCHVIEW,
    AssignmentAction,
    ChangeAdapterAction,
    CloseDocumentAction,
    DialogExpressionAction,
    DialogMessageAction,
    ExitAction,
    QueryAction,
    SubmitAction,
} from './ruleActions';

// (Action, DataSourceNode) -> Promise[ActionResult]
async function performAssignmentAsync(action, context) {
    const targetNodes = context.selectNodes(action.target);

    if (targetNodes && targetNodes.length) {
        const value = context.evaluateString(action.expression);

        for (const node of targetNodes) {
            const result = await node.setValueAsync(value);

            if (result && result.shouldStop) {
                return result.status === CLOSE
                    ? ACTION_RESULT_CLOSE
                    : ACTION_RESULT_NORMAL;
            }
        }
    }

    return ACTION_RESULT_NORMAL;
}

// String -> void
function showDialog(text) {
    alert(text);
}

// (Action, DataSourceNode) -> void
function showDialogExpression(action, context) {
    const result = context.evaluateString(action.expression);

    showDialog(result);
}

// Action -> void
function showDialogMessage(action) {
    showDialog(action.message);
}

// (ViewManager, Action) -> Promise[void]
const performSwitchViewAction = async (viewManager, action) => {
    await viewManager.setCurrentView(action.view);
};

// (DataConnectionCollection, Action) -> DataConnection
function getConnectionForAction(dataConnections, action) {
    const name = action.adapterName;

    if (!name) {
        throw new TypeError('Adapter name was unspecified.');
    }

    const adapter = dataConnections.get(name);

    if (!adapter) {
        throw new Error('No adapter found for name ' + name);
    }

    return adapter;
}

// (DataConnectionCollection, Action) -> Promise[void]
function performSubmitActionAsync(dataConnections, action) {
    var connection = getConnectionForAction(dataConnections, action);

    return connection.submitAsync();
}

// (DataConnectionCollection, Action) -> Promise[void]
function performQueryActionAsync(dataConnections, action) {
    var connection = getConnectionForAction(dataConnections, action);

    return connection.queryAsync();
}

// (DataConnectionCollection, Action, DataSourceNode) -> void
function performChangeAdapterProperty(dataConnections, action, context) {
    const connection = getConnectionForAction(dataConnections, action);
    const expression = context.evaluateString(action.expression);
    const adapterProperty = action.adapterProperty;

    if (!adapterProperty) {
        console.warn(
            'Adapter property name unspecified in change adapter property action.',
        );
    } else if (adapterProperty === 'FileURL') {
        connection.setUrl(expression, action.adapterProperty);
    } else {
        console.warn(
            'Adapter property ' +
                adapterProperty +
                ' is not currently supported.',
        );
    }
}

function actionExecutor(dataConnections, viewManager) {
    // (Action, DataSourceNode) -> Promise[ActionResult | void | null]
    async function runActionAsync(action, context) {
        const actionType = action.actionType;

        switch (actionType) {
            case AssignmentAction.type:
                return performAssignmentAsync(action, context);

            case DialogExpressionAction.type:
                return showDialogExpression(action, context);
            case DialogMessageAction.type:
                return showDialogMessage(action);

            case ACTION_TYPE_SWITCHVIEW:
                await performSwitchViewAction(viewManager, action);
                return null;

            case SubmitAction.type:
                return performSubmitActionAsync(dataConnections, action);
            case QueryAction.type:
                return performQueryActionAsync(dataConnections, action);

            case ChangeAdapterAction.type:
                return performChangeAdapterProperty(
                    dataConnections,
                    action,
                    context,
                );

            case CloseDocumentAction.type:
                return ACTION_RESULT_CLOSE;

            case ExitAction.type:
                return ACTION_RESULT_STOP_RULESET;
            default:
                console.warn('Unsupported action type: ' + actionType);
                return null;
        }
    }

    return {
        runActionAsync,
    };
}

export default actionExecutor;
